namespace Indexes {
    export class None
        implements StaticIndexDefinition {
        name = "@all_docs";
        maps = [];
        
    }
}